//{% if template.name == 'collection' or template.name == 'search' or template.name == 'product' %}
document.addEventListener('DOMContentLoaded', function () {
  function cleanJudgeMeBadges(scope) {
    const root = scope || document;

    root.querySelectorAll('.jdgm-prev-badge__text').forEach(function (el) {
      const txt = (el.textContent || '').trim().toLowerCase();

        const NO_REVIEW_TEXTS = new Set([
  'no reviews',
  'no review',
  '(0)',
  '0 reviews',
  '0 review',
  'avis',
  'keine bewertungen'
        ]);

      if (NO_REVIEW_TEXTS.has(txt)) {
        el.style.display = 'none';
        el.textContent = '';
        
      }
    });
  }

  function refreshJudgeMe(scope) {
    cleanJudgeMeBadges(scope);

    if (window.jdgm && typeof window.jdgm.refreshBadges === 'function') {
      window.jdgm.refreshBadges();
    }

    setTimeout(function () {
      cleanJudgeMeBadges(scope);
    }, 300);

    setTimeout(function () {
     cleanJudgeMeBadges(scope);
    }, 900);

    setTimeout(function () {
     cleanJudgeMeBadges(scope);
    }, 6500);
  }

  refreshJudgeMe(document);

  const productGrid =
    document.querySelector('#ProductGridContainer') ||
    document.querySelector('#product-grid') ||
    document.querySelector('.product-grid') ||
    document.querySelector('[data-id*="product-grid"]');

  if (productGrid) {
    const observer = new MutationObserver(function () {
      refreshJudgeMe(productGrid);
    });

    observer.observe(productGrid, {
      childList: true
      //subtree: true
    });
  }

  document.addEventListener('change', function (e) {
    const el = e.target;
    if (el && (el.matches('select[name="sort_by"]') || el.matches('#SortBy'))) {
      setTimeout(function () {
        refreshJudgeMe(document);
      }, 300);

      setTimeout(function () {
        refreshJudgeMe(document);
      }, 900);

      setTimeout(function () {
        refreshJudgeMe(document);
      }, 6500);
    }
  });

  document.addEventListener('input', function (e) {
    const el = e.target;
    if (el && (el.matches('select[name="sort_by"]') || el.matches('#SortBy'))) {
      setTimeout(function () {
        refreshJudgeMe(document);
      }, 300);

      setTimeout(function () {
        refreshJudgeMe(document);
      }, 900);

      setTimeout(function () {
        refreshJudgeMe(document);
      }, 6500);
    }
  });
});
// {% endif %}